// Giorno selezionato del calendario — helpers.
//
// Convenzione di piattaforma: gli orari delle prenotazioni sono "orario
// del muro" salvato come UTC (`2026-06-12T19:30:00Z` = le 19:30 in sala),
// quindi il giorno di una prenotazione è SEMPRE startsAt.slice(0, 10) e
// ogni formattazione qui usa timeZone UTC.
import type { DateLabel } from '../data/types';

/** Oggi per il ristorante (i locali sono in Italia → Europe/Rome), come YYYY-MM-DD. */
export function todayRome(): string {
  // en-CA dà direttamente il formato ISO YYYY-MM-DD.
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Rome' });
}

/** Ora attuale a Roma in minuti dalla mezzanotte (per la linea "adesso" della timeline). */
export function romeNowMin(): number {
  const hhmm = new Date().toLocaleTimeString('en-GB', {
    timeZone: 'Europe/Rome',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const [h, m] = hhmm.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
}

/** day ± delta giorni, restando in YYYY-MM-DD. */
export function addDays(day: string, delta: number): string {
  const d = new Date(`${day}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + delta);
  return d.toISOString().slice(0, 10);
}

const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Etichetta bilingue del giorno per topbar e intestazioni. */
export function dateLabelFor(day: string): DateLabel {
  const d = new Date(`${day}T12:00:00Z`);
  const part = (locale: string, opts: Intl.DateTimeFormatOptions) =>
    d.toLocaleDateString(locale, { ...opts, timeZone: 'UTC' });
  return {
    it: {
      dow: cap(part('it-IT', { weekday: 'long' })),
      d: String(d.getUTCDate()),
      mon: part('it-IT', { month: 'long' }),
      y: String(d.getUTCFullYear()),
    },
    en: {
      dow: part('en-GB', { weekday: 'long' }),
      d: String(d.getUTCDate()),
      mon: part('en-GB', { month: 'long' }),
      y: String(d.getUTCFullYear()),
    },
  };
}
